// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const VmwareIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="-6 -82 265 265">
    <path d="M26.7 8.2C23.5 1.2 15.6-2 8.2 1.3S-1.9 12.8 1.4 19.8l31 67.4c4.9 10.6 10 16.1 19.7 16.1 10.3 0 14.8-6 19.7-16.1 0 0 27-58.9 27.3-59.5s1.1-2.5 3.9-2.5c2.3 0 4.3 1.9 4.3 4.4v57.6c0 8.9 4.9 16.2 14.4 16.2s14.6-7.3 14.6-16.2V40.1c0-9.1 6.5-15 15.4-15s14.8 6.1 14.8 15v47.1c0 8.9 4.9 16.2 14.4 16.2s14.6-7.3 14.6-16.2V40.1c0-9.1 6.5-15 15.4-15s14.8 6.1 14.8 15v47.1c0 8.9 4.9 16.2 14.4 16.2s14.6-7.3 14.6-16.2V33.6c0-19.7-15.8-33.5-34.9-33.5-19 0-31 13.2-31 13.2C182.5 5 173.7 0 158.9 0c-15.6 0-29.3 13.2-29.3 13.2C123.3 5 112.5 0 103.5 0 89.7.1 78.7 6.2 72 21.5L52.2 68.2z" />
  </svg>,
  "Vmware",
);
export default VmwareIcon;
